import React from 'react';
import PropTypes from 'prop-types';

import { getProfileURL } from 'lib/social';

function SocialProfileList(props) {
  const {
    profiles,
  } = props;

  const keys = Object.keys(profiles).filter((i) => profiles[i]);

  return (
    <>
      {Array.isArray(keys) && keys.length > 0 && (
        <ul className="social-profile-list">
          {['twitter', 'facebook', 'instagram', 'pinterest', 'youtube']
            .map((profile) => {
              if (keys.includes(profile)) {
                return (
                  <li
                    className="social-profile-list__item"
                    key={profile}
                  >
                    <a href={getProfileURL(profile, profiles[profile])}>
                      <span className={`icon icon-${profile}`} />
                    </a>
                  </li>
                );
              }
              return null;
            })}

          {keys.includes('email') && (
            <li className="social-profile-list__item">
              <a href={`mailto:${profiles.email}`}>
                <span className="icon icon-email" />
              </a>
            </li>
          )}
        </ul>
      )}
    </>
  );
}

SocialProfileList.propTypes = {
  profiles: PropTypes.shape({
    email: PropTypes.string,
    facebook: PropTypes.string,
    instagram: PropTypes.string,
    pinterest: PropTypes.string,
    twitter: PropTypes.string,
    youtube: PropTypes.string,
    // Not yet implemented
    // snapchat: PropTypes.string,
    // tiktok: PropTypes.string,
    // whatsapp: PropTypes.string,
  }),
};

SocialProfileList.defaultProps = {
  profiles: {
    email: null,
    facebook: null,
    instagram: null,
    pinterest: null,
    twitter: null,
    youtube: null,
    // Not yet implemented
    // snapchat: null,
    // tiktok: null,
    // whatsapp: null,
  },
};

export { SocialProfileList };
